import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AddVehicleCustomerModel } from '../business-entities/add-vehicle-customer-model';
import { AdditionalService } from '../business-entities/additional-service.interface';
import { BrandViewModel } from '../business-entities/brand.interface';
import { DealerService, PlanningSlots, ReservedSlot } from '../business-entities/dealer-service.interface';
import { Panel } from '../business-entities/panel.class';
import { GenericRentalCar, RentalCar } from '../business-entities/rental-car.interface';
import { Step } from '../business-entities/step.class';
import { VehicleCustomerDetails } from '../business-entities/vehicle-customer-details.interface';
import { VerifiedCustomer } from '../business-entities/verified-customer.interface';
import { WidgetCustomerVehicleDetails } from '../business-entities/widget-customer-vehicle-details-model';
import { SummaryService } from '../business-services/summary.service';
import { AppState } from './../business-entities/app-state.interface';
import { Customer } from './../business-entities/customer.interface';
import { ServiceCategoryDetails } from './../business-entities/service-details.interface';
import { Service } from './../business-entities/service.interface';
import { Vehicle } from './../business-entities/vehicle.interface';
import * as Constants from './../utils/contstants';
import * as Enums from './../utils/enums';
import { UploadDocumentRequestModel } from '../../../../Autofacets-Core/src/app/business-entities/upload-document-request-model';

interface ServiceSectionDetails {
    selectedService: Service[];
    carCode: string;
    mileage: number;
    stoneChipInput: string;
    bodyBrokenIconPositions: { left: number; top: number }[];
    damageIconImage: string;
    otherIssuesInput: string;
    damageDescription: string;
  }
interface workshopSectionDetails {
    selectedDealer: DealerService,
    selectedDate: string,
    displaySelectedDate: Date,
    timeSlotSection: boolean,
    availCheckInFacility: boolean,
    deliverCarWithinBusinessHours: boolean,
    pickupCarWithinBusinessHours: boolean,
    isNeedRentalCar: boolean,
    selectedRentalCar: RentalCar,
    rentalCarDetails: RentalCar[],
    additionalComments: string,
    customerPickupDropOffServiceSelection: boolean,
    PickupDatetime: Date,
    pickUpHours: number,
    pickUpMinutes: number,
    AppointmentDateTime: Date,
    appointmentHour: number,
    appointmentMinute: number,
    selectedSlot: any
}
@Injectable({
    providedIn: 'root'
})
export class CommonService {
    private appData: AppState = {
        dealerRecommendedService: undefined,
        selectedRentalCar:undefined
    };
    private readonly steps: Step[] = Constants.stepsInitialData;
    private readonly panels: Panel[] = Constants.panelInitialData;
    private isCustomerValidated = false;
    private isAppointmentCreated = false;
    private isFromSingleCarSection = false;
    public stepsChanged = new Subject<Step[]>();
    public panelsChanged = new Subject<Panel[]>();
    private isAddedNewVehicle= false;
    private isOtpVerified = false;
    brandList: BrandViewModel[];
    dealerRecommendedService:AdditionalService[] = [];
    customerPhone:string;
    newVehicleArray:Vehicle[] = [];
    existingVehicleCustomerDetails:WidgetCustomerVehicleDetails[] = [];
    selectedCustomerVehicleDetails:WidgetCustomerVehicleDetails;
    driverId: string;
    vehicleId: string;
    allWarningLight:any;
    uploadDocumentViewModel:UploadDocumentRequestModel[]=[]
    
    expirationTimer: number;
    timerIntervalObject: any;
    public isCreationExpired: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(
        private readonly datePipe: DatePipe,
        private readonly brandService: SummaryService
    ) { }


    addCustomerGuid(customerGuid: string)
    {
        this.appData.customerDetails.customerGuid= customerGuid;
    }
    addVerifiedCustomerdetails(details: VerifiedCustomer): void{
        this.appData.customerDetails.firstName = details.customerName;
        this.appData.customerDetails.lastName = "";
        this.appData.customerDetails.mobileNo = details.mobileNumber;
        this.appData.customerDetails.email = details.email;
        this.appData.customerDetails.zipcode = details.zipcode;
    }
    addCustomerAndVehicleDetailsSingle(details: VehicleCustomerDetails): void {
        const customerDetails: Customer = {
            customerGuid: details.customerGuid,
            firstName: details.firstName,
            lastName: details.lastName,
            address1: details.address1,
            address2: details.address2,
            zipcode: details.zipcode,
            city: details.city,
            state: details.state,
            countryId: details.countryId,
            mobileNo: details.mobileNo,
            email: details.email,
            latitude: details.latitude,
            longitude: details.longitude,
            country: details.country,
            mobileCode: details.mobileCode,
        };
        const vehicleDetails: Vehicle = {
            vehicleGuid: details.vehicleGuid,
            licensePlate: details.licensePlate,
            engineSerialNo: details.engineSerialNo,
            makeCode: details.makeCode,
            model: details.model,
            makeName: details.makeName,
            mchCode: details.mchCode,
            registrationDate: details.registrationDate,
            color: details.color,
            year: details.year,
            chassisNo: details.chassisNo,
            previousKilometer:details.previousKilometer
        };
        if (this.appData.customerDetails && this.appData.customerDetails.customerGuid !== details.customerGuid) {
            this.appData.dealerServiceDetails = undefined;
            this.appData.selectedDealer = undefined;
            this.appData.selectedDate = undefined;
            this.appData.selectedSlot = undefined;
            this.appData.displaySelectedDate = undefined;
            this.appData.availCheckInFacility = undefined;
            this.appData.deliverCarWithinBusinessHours = undefined;
            this.appData.pickupCarWithinBusinessHours = undefined;
            this.appData.selectedRentalCar = undefined;
            this.appData.rentalCars = undefined;
            this.appData.additionalComments = undefined;
            this.appData.selectedAdditionService = undefined;
        }
        this.isFromSingleCarSection = true;
        this.appData.customerDetails = customerDetails;
        this.appData.vehicleDetails = [vehicleDetails];
        this.appData.selectedVehicleDetails = vehicleDetails;
    }

    addPrefferedDealerdetails(details: DealerService){
        const preferredDealerdetails: DealerService = {
            dealerId: details.dealerId,
            dealerName: details.dealerName,
            address: details.address,
            city: details.city,
            state: details.state,
            pincode: details.pincode,
            country: details.country,
            latitude: details.latitude,
            landlineCode :details.landlineCode,
            longitude: details.longitude,
            service: details.service,
            holidaysList: details.holidaysList,
            openingHoursList: details.openingHoursList,
            nextAvailableDate: details.nextAvailableDate,
            distance: details.distance,
            contact:details.contact,
            email:details.email,
            isVehiclePickUpAndDropOffService:details.isVehiclePickUpAndDropOffService,
            notAvailableServices:details.notAvailableServices,
            occasionWiseOpeningHoursList:details.occasionWiseOpeningHoursList
        };
        this.appData.preferedDealer = preferredDealerdetails;
    }

    addDealerServiceDetails(details: DealerService[]): void {
        this.appData.dealerServiceDetails = details;
    }

    addGenericRentalCarData(isGenericRentalCar:boolean, genericRentalCar:GenericRentalCar){
        this.appData.isGenericRentalCar = isGenericRentalCar;
        this.appData.genericRentalCar = genericRentalCar;
    } 
    
    addSelectedRentalCar(rentalCar:any){
        this.appData.selectedRentalCar = rentalCar;
    }
    
    addPlanningDate(startDate:Date,endDate:Date,mechanicId){
        this.appData.planningStartTime = startDate;
        this.appData.planningEndTime = endDate;
        this.appData.mechanicId = mechanicId;
    }
    addPlanningSlots(model:PlanningSlots[]){
        this.appData.planningSlots = model;
    }
    addSelectedSlot(slot:any){
        this.appData.selectedSlot = slot;
    }
    getAppData(): AppState {
        return { ...this.appData };
    }
    addReserveSlot(slotId:ReservedSlot[],startTime:string){
        this.appData.reserveSlotId = [];
        this.appData.reserveSlotId = slotId;
        this.appData.selectedStartTime=startTime;
    }
    addSplitSlot(model:any){
        this.appData.splitSlots = model;
    }
    get GetAppointmentStatus(): boolean {
        return this.isAppointmentCreated;
    }

    setAppointmentCreated( appointmentGuid: string): void {
        this.isAppointmentCreated = true;
        this.appData.appointmentGuid = appointmentGuid;
    }

    validateCustomer(): void {
        this.isCustomerValidated = true;
    }
    validateOtp(): void {
        this.isOtpVerified = true;
    }
    checkvalidateOtp(): boolean {
        return this.isOtpVerified;
    }

    checkCustomerValidtion(): boolean {
        return this.isCustomerValidated;
    }

    validateAddedCustomerDeatils(): void {
        this.isAddedNewVehicle = true;
    }

    checkAddedCustomerDeatils(): boolean {
        return this.isAddedNewVehicle;
    }
    addCustomerAndVehicleDetailsMultiple(customerDetails: Customer, vehicleDetails: Vehicle[], selectedVehicleDetails: Vehicle): void {
        this.isFromSingleCarSection = false;
        this.appData.customerDetails = customerDetails;
        this.appData.vehicleDetails = vehicleDetails;
        this.appData.selectedVehicleDetails = selectedVehicleDetails;
    }
    addNewVehicleCustomer(newVehicleCustomerModel: AddVehicleCustomerModel): void {
        this.appData.newVehicleCustomerModel = newVehicleCustomerModel;
    }
    saveNewVehicleArray(vehicles :Vehicle[]):void{
        this.newVehicleArray = vehicles;
    }
    getNewVehicleArray():any{
        return this.newVehicleArray;
    }
    OnChangePhoneNoBack(){
        this.panels[0].selectedValue = '';
    }

    addUserAuthMobile(mobile: string): void {
        this.appData.userAuthMobile = mobile;
    }
    getUserAuthMobile(): string {
        return this.appData.userAuthMobile;
    }

    addUserAuthMobileCode(mobileCode: string): void {
        this.appData.userAuthMobileCode = mobileCode;
    }
    getUserAuthMobileCode(): string {
        return this.appData.userAuthMobileCode;
    }

    addServiceAndCategoryDetails(details: ServiceCategoryDetails[],language: string): void {
        this.appData.serviceAndCategoryDetails = details;
        this.appData.currentLanguage = language;
    }

    addSelectServiceSectionDetails(details: ServiceSectionDetails): void {
        const{
            selectedService,
            carCode,
            mileage,
            stoneChipInput,
            bodyBrokenIconPositions,
            damageIconImage,
            otherIssuesInput,
            damageDescription
        } = details;


        this.appData.selectedService = selectedService;
        this.appData.carCode = carCode;
        this.appData.mileage = mileage;
        this.appData.stoneChipInput = stoneChipInput;
        this.appData.bodyBrokenIconPositions = bodyBrokenIconPositions;
        this.appData.damageIconImage = damageIconImage;
        this.appData.otherIssuesInput = otherIssuesInput;
        this.appData.damageDescription = damageDescription;
    }

    updateServicePrice(dealerService:any[])
    {
        this.appData.selectedService.forEach(x=>{
            dealerService.forEach(y=>{
                if(y.serviceId===x.id && x.isFixed === false){
                    x.price=y.price;
                    x.priceIncVat=y.priceIncVat
                }
            })
        });
    }

    addSelectWorkshopSectionDetails(details: workshopSectionDetails): void {
        const{
            selectedDealer,
            selectedDate,
            displaySelectedDate,
            timeSlotSection,
            availCheckInFacility,
            deliverCarWithinBusinessHours,
            pickupCarWithinBusinessHours,
            isNeedRentalCar,
            selectedRentalCar,
            rentalCarDetails,
            additionalComments,
            customerPickupDropOffServiceSelection,
            PickupDatetime,
            pickUpHours,
            pickUpMinutes,
            AppointmentDateTime,
            appointmentHour,
            appointmentMinute,
            selectedSlot
        }=details;

        this.appData.selectedDealer = selectedDealer;
        this.appData.selectedDate = selectedDate;
        this.appData.displaySelectedDate=displaySelectedDate;
        this.appData.timeSlotSection=timeSlotSection;
        this.appData.availCheckInFacility = availCheckInFacility;
        this.appData.deliverCarWithinBusinessHours = !timeSlotSection ? deliverCarWithinBusinessHours : null;
        this.appData.pickupCarWithinBusinessHours = !timeSlotSection ? pickupCarWithinBusinessHours : null;
        this.appData.selectedRentalCar = !timeSlotSection && isNeedRentalCar ? selectedRentalCar : null;
        this.appData.rentalCars = !timeSlotSection && isNeedRentalCar ? rentalCarDetails : null;
        this.appData.additionalComments = additionalComments;
        this.appData.isPickupDropOffServiceSelection=customerPickupDropOffServiceSelection;
        this.appData.pickupDatetime=customerPickupDropOffServiceSelection ? PickupDatetime :null;
        this.appData.pickUpMinutes = pickUpMinutes;
        this.appData.pickUpHours = pickUpHours;
        this.appData.appointmentDateTime = AppointmentDateTime;
        this.appData.appointmentHour = appointmentHour;
        this.appData.appointmentMinute = appointmentMinute;
        this.appData.selectedSlot = selectedSlot;
    }
    removeSlotSelections(): void {
        this.appData.selectedDate = null;
        this.appData.displaySelectedDate = null;
        this.appData.timeSlotSection = null;
        this.appData.appointmentDateTime = null;
        this.appData.appointmentHour = null;
        this.appData.appointmentMinute = null;
        this.appData.selectedSlot = null;
    }

    addselectedAdditionService(additionServicesForm:any,dealerRecommendedService:any)
    {
        this.appData.selectedAdditionService=additionServicesForm ? additionServicesForm.value : null;
        this.appData.dealerRecommendedService=dealerRecommendedService
    }

    updateContactDetails(zipCode: string, email: string): void {
        this.selectedCustomerVehicleDetails.PINCODE = zipCode;
        this.selectedCustomerVehicleDetails.CUST_EMAILID = email;
    }

    addNomineeDetails(name: string, mobile: string, dialcode: string): void {
        this.selectedCustomerVehicleDetails.nomineeName = name;
        this.selectedCustomerVehicleDetails.nomineeMobileNumber = mobile;
        this.selectedCustomerVehicleDetails.nomineeMobileCode = dialcode;
    }

    getSteps(): Step[] {
        return this.steps.slice();
    }

    getFormatedDate(date: string): Date {
        if (date) {
            const arr = date.split('.').reverse().join('-');
            return new Date(arr);
        }
        return new Date();
    }

    getBrandLogo(): any {
    if(this.brandService.brandList.length === 0){
      this.brandService.getBrand().then(res => {
        if (res) {
          this.brandList = res;
          if (this.brandList) {
            return this.brandList;
          }
        }
      }
      )
    }
    else{
      this.brandList = this.brandService.brandList;
      return this.brandList;
    }
    }

    getPanels(): Panel[] {
        return this.panels.slice();
    }

    canGoToPanel(panelId: string): boolean {
        switch (panelId) {
            case Enums.PanelIds.Panel1:
                return true;
            case Enums.PanelIds.Panel2:
                if (this.panels[0].isCompleted && this.selectedCustomerVehicleDetails) {
                    return true;
                }
                break;
            case Enums.PanelIds.Panel3:
                if (this.panels[1].isCompleted && this.appData.selectedService && this.appData.selectedService.length > 0) {
                    return true;
                }
                break;
            case Enums.PanelIds.Panel4:
                if (this.panels[2].isCompleted && this.appData.selectedDealer && this.appData.selectedDate) {
                    return true;
                }
                break;
            case Enums.PanelIds.Panel5:
                if (this.panels[3].isCompleted && this.appData.selectedDealer && this.appData.selectedDate) {
                     return true;
                }
                 break;
        }
        return false;
    }

    completePanel(panelId: string): void {    
        switch (panelId) {
            case Enums.PanelIds.Panel1:
                this.panels[0].isCompleted = true;
                this.panels[0].selectedValue = `${this.selectedCustomerVehicleDetails.companyMakeName} | ${this.selectedCustomerVehicleDetails.licensePlateNo}`;
                this.clearDetails();
                this.completeStep(1);
                break;
            case Enums.PanelIds.Panel2:
                this.panels[1].isCompleted = true;
                let selectedService = '';
                this.appData.selectedService.forEach(x => {
                    selectedService += x.name + ', ';
                });
                this.panels[1].selectedValue = selectedService.slice(0, selectedService.lastIndexOf(','));
                this.completeStep(2);
                break;
            case Enums.PanelIds.Panel3:
                this.panels[2].isCompleted = true;
                this.panels[2].selectedValue = this.appData.selectedDealer.dealerName + ' | ' +
                this.datePipe.transform(this.appData.displaySelectedDate, 'shortDate')
                this.completeStep(3);
                break;
            case Enums.PanelIds.Panel4:
                this.panels[3].isCompleted = true;
                this.completeStep(4);
                break;
        }
        this.panelsChanged.next(this.panels.slice());
    }
    changePanelTitle(){
        this.panels[0].selectedValue = this.appData.licensePlate;
    }
    clearDetails(): void {
        this.panels.forEach((item, index) => {
            if (index !== 0) {
                item.isCompleted = false;
                item.selectedValue = null;
            }
        });
        this.panelsChanged.next(this.panels.slice());
        this.steps.forEach((item, index) => {
            if (index != 0) {
                item.isActive = false;
                item.isCompleted = false
            } else {
                item.isActive = true;
            }
        });
        this.stepsChanged.next(this.steps.slice());
        this.isCustomerValidated = this.isFromSingleCarSection ? false : this.isCustomerValidated;
        this.appData = {
            customerDetails: this.appData.customerDetails,
            vehicleDetails: this.appData.vehicleDetails,
            selectedVehicleDetails: this.appData.selectedVehicleDetails,
            userAuthMobile: this.appData.userAuthMobile,
            userAuthMobileCode: this.appData.userAuthMobileCode,
        };
    }

    completeStep(stepNo: number): void {
        this.steps[stepNo - 1].isCompleted = true;
        this.steps[stepNo - 1].isActive = false;
        if (this.steps.length > stepNo) {
            this.steps[stepNo].isActive = true;
        }
        this.stepsChanged.next(this.steps.slice());
    }
    addCustomerPhone(phone:string):void{
        this.customerPhone = phone;
    }
    getCustomerPhone():string{
        return this.customerPhone;
    }
    addExistingCustomerVehicleDetails(existingVehicleCustomerDetails):void{
        this.existingVehicleCustomerDetails = existingVehicleCustomerDetails;
    }
    getExistingCustomerVehicleDetails():any{
        return this.existingVehicleCustomerDetails;
    }
    addSelectedCustomerVehicleDetails(selectedVehicleCustomerDetails):void{
        this.selectedCustomerVehicleDetails = selectedVehicleCustomerDetails;
    }
    getSelectedCustomerVehicleDetails():any{
        return this.selectedCustomerVehicleDetails;
    }
    addCalenderNumber(calenderNumber: number)    {
        this.appData.calenderNumber = calenderNumber;
    }
    addDocument(model:UploadDocumentRequestModel){
        let index = this.uploadDocumentViewModel.findIndex(x => x.uniqueId == model.uniqueId);
        if(index >= 0){
            this.uploadDocumentViewModel[index] = model;
        }
        else{
            this.uploadDocumentViewModel.push(model)
        }
    }
    getDocument(uniqueId){
        return this.uploadDocumentViewModel?.filter(x => x.uniqueId == uniqueId);        
    }
    removeDocument(uniqueId){
        let index =  this.uploadDocumentViewModel.findIndex(x => x.uniqueId == uniqueId);
        this.uploadDocumentViewModel?.splice(index,1);
    }
    getAllDocument(){
        return this.uploadDocumentViewModel;
    }
    startExpireTimer(minutes: number){
        this.isCreationExpired.next(false);
        this.expirationTimer = (minutes*60); //seconds 
        if (this.timerIntervalObject) {
            clearInterval(this.timerIntervalObject);
        }
        this.timerIntervalObject = setInterval(()=>{
            if(this.expirationTimer > 0)
            {
                this.expirationTimer = this.expirationTimer - 1;
            }
            else{
                this.isCreationExpired.next(true);
                clearInterval(this.timerIntervalObject);
            }
        }, 1000)
    }
    stopExpireTimer(){
        this.expirationTimer = 0;
        clearInterval(this.timerIntervalObject);
    }
    secondsToTime(total_seconds){
        if (total_seconds > 0) {
            const dateObj = new Date(total_seconds * 1000);
            let minutes = dateObj.getUTCMinutes();
            let seconds = dateObj.getSeconds();
    
            let timeString = minutes.toString().padStart(2, '0') + ':' + 
                seconds.toString().padStart(2, '0');
            return timeString;   
        }
        return "";
    }
}
